$('.image-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    prevArrow: '<div class="prev-arrow flex items-center justify-center absolute bg-secondary rounded-l-lg z-10  fas fa-chevron-left text-xl text-white cursor-pointer"></div>',
    nextArrow: '<div class="next-arrow flex items-center justify-center absolute bg-secondary-light right-0 z-10 fas fa-chevron-right text-xl text-white cursor-pointer"></div>'
});

jQuery('.slick-carousel.footer-certificate-logo-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
        }
    ]
});